import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import RoadClosureDialog from './RoadClosureDialog.jsx';
import './RoadClosures.css';

export default class RoadClosures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      value: 1,
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen() {
    this.setState({
      open: true
    });
  }

  handleClose() {
    this.setState({
      open: false
    })
  }

  handleChange = (event, index, value) => this.setState({value});

  render() {
    return (
      <div>
        <div className="open-pace-predictor">
          <RaisedButton label="Road closures"
            onClick={this.handleOpen} />
        </div>
        <Dialog
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
          contentClassName="pace-predictor-dialog"
          autoScrollBodyContent={true}
        >
          <RoadClosureDialog map={this.props.map} />
        </Dialog>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/marathon/RoadClosures.jsx